export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      serviceAttributeType: {
        attributeTypeId: 1,
        attributeTypeUUID: "attributetypes001",
        attributeTypeName: "町内会",
        deliveryTypeCode: "chonaikai",
        attributeCounts: 9,
        deliveryFlg: true,
        attributeTypeStatus: 1,
        attributeGroups: [
          {
            attributeGroupUuid: "attributegroup002", 
            attributeGroupOrder: 2,
            attributeGroupName: "〇〇町内会",
            attributeGroupCode: "marumaru",
            attributeGroupMailAddress: "aaa@aaa.com"
          },
          {
            attributeGroupUuid: "attributegroup001", 
            attributeGroupOrder: 1,
            attributeGroupName: "△△町内会",
            attributeGroupCode: "sankaku",
            attributeGroupMailAddress: "bbb@bbb.com"
          }
        ] 
      }
    }
  }
}